import { createContext, useContext, useMemo, useState } from 'react';

const initialState = {
  getTeamEditorAlertDismissed: () => false,
  dismissTeamEditorAlert: () => {},
};

export const AlertContext = createContext(initialState);

export const AlertContextProvider = ({ children }) => {
  // The set of teamIds for which the notification has been closed.
  const [editorAlertDismissed, setEditorAlertDismissed] = useState(new Set());

  const value = useMemo(
    () => ({
      getTeamEditorAlertDismissed: (teamId) => editorAlertDismissed.has(teamId),
      dismissTeamEditorAlert: (teamId) => {
        setEditorAlertDismissed((prev) => new Set(prev).add(teamId));
      },
    }),
    [editorAlertDismissed],
  );

  return (
    <AlertContext.Provider value={value}>{children}</AlertContext.Provider>
  );
};

export const useAlertContext = () => useContext(AlertContext);
